export const API_URL = "https://verify.pilot.dexcart.in/api/";